/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Enus2Inputs */

const he_locale_enus2 = /** @type {(inputs: Locale_Enus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English (US)`)
};

const en_locale_enus2 = /** @type {(inputs: Locale_Enus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English (US)`)
};

/**
* | output |
* | --- |
* | "English (US)" |
*
* @param {Locale_Enus2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const locale_enus2 = /** @type {((inputs?: Locale_Enus2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Enus2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_locale_enus2(inputs)
	return en_locale_enus2(inputs)
});
export { locale_enus2 as "locale_enUS" }